import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getCollectionWorker);

import { call, put } from 'redux-saga/effects';
import { Endpoints } from '../../api/Constants';
import { validateJson } from '../../utils/jsonschema/validator';
import handleLoggerErrorEvents from './handleLoggerErrorEvents';
import { ACTION } from './constants';
export function getCollectionWorker(_ref) {
  var payload, type, target, response;
  return _regeneratorRuntime.wrap(function getCollectionWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload, type = _ref.type;
          target = type.slice(0, type.lastIndexOf('/'));
          _context.next = 4;
          return put(ACTION[target].isFetching(true));

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return call(ACTION[target].fetchData, payload);

        case 7:
          response = _context.sent;

          if (!validateJson(Endpoints[target], response)) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return put(ACTION[target].requestDataSuccess(response));

        case 11:
          _context.next = 18;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](4);
          _context.next = 17;
          return put(ACTION[target].requestError(_context.t0));

        case 17:
          handleLoggerErrorEvents(_context.t0);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 13]]);
}